(function () {
  const root = document.querySelector('[data-inset-gas-pdp]');
  if (!root) return;

  const form = root.querySelector('[data-product-form]');
  const variantInput = form && form.querySelector('[data-product-variant]');
  if (!form || !variantInput) return;

  const jsonEl = form.querySelector('[data-product-json]');
  let variants = [];
  try {
    variants = JSON.parse(jsonEl.textContent);
  } catch (error) {
    return;
  }

  const gasBtns = root.querySelectorAll('[data-inset-gas]');
  const fuelBtns = root.querySelectorAll('[data-inset-fuel]');
  const controlBtns = root.querySelectorAll('[data-inset-control]');
  const gallery = root.querySelector('[data-inset-gallery]');
  const stage = gallery && gallery.querySelector('[data-inset-stage]');
  const thumbs = gallery ? gallery.querySelectorAll('[data-inset-thumb]') : [];

  function current() {
    return {
      gas: root.getAttribute('data-selected-gas') || 'ng',
      fuel: root.getAttribute('data-selected-fuel') || 'coals',
      control: root.getAttribute('data-selected-control') || 'manual',
    };
  }

  function findVariant(sel) {
    return variants.find((entry) => {
      if (entry.gas !== sel.gas) return false;
      if (entry.effect !== sel.fuel) return false;
      if (entry.control !== sel.control) return false;
      return true;
    });
  }

  function comboExists(partial) {
    return variants.some((entry) => {
      if (partial.gas && entry.gas !== partial.gas) return false;
      if (partial.fuel && entry.effect !== partial.fuel) return false;
      if (partial.control && entry.control !== partial.control) return false;
      return true;
    });
  }

  function setPressed(buttons, attr, value) {
    buttons.forEach((btn) => {
      const on = btn.getAttribute(attr) === value;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function syncControlAvailability(sel) {
    controlBtns.forEach((btn) => {
      const value = btn.getAttribute('data-inset-control');
      const ok = comboExists({ gas: sel.gas, fuel: sel.fuel, control: value });
      btn.disabled = !ok;
      if (!ok && value === sel.control) {
        root.setAttribute('data-selected-control', 'manual');
      }
    });
  }

  function preferredMedia(fuel) {
    const order =
      fuel === 'logs'
        ? ['lifestyle-logs', 'product-logs', 'lifestyle-coals', 'product-coals', 'technical']
        : ['lifestyle-coals', 'product-coals', 'lifestyle-logs', 'product-logs', 'technical'];
    for (let i = 0; i < order.length; i += 1) {
      const thumb = gallery && gallery.querySelector('[data-inset-thumb][data-role="' + order[i] + '"]');
      if (thumb) return thumb;
    }
    return thumbs[0] || null;
  }

  function showThumb(thumb) {
    if (!thumb || !stage) return;
    const src = thumb.getAttribute('data-full-src');
    const srcset = thumb.getAttribute('data-full-srcset') || '';
    const alt = thumb.getAttribute('data-full-alt') || '';
    const img = stage.querySelector('img');
    if (img && src) {
      img.src = src;
      if (srcset) img.srcset = srcset;
      img.alt = alt;
      stage.setAttribute('data-role', thumb.getAttribute('data-role') || '');
    }
    thumbs.forEach((other) => other.classList.toggle('is-active', other === thumb));
  }

  function apply(updateGallery) {
    const sel = current();
    syncControlAvailability(sel);
    const resolved = current();
    setPressed(gasBtns, 'data-inset-gas', resolved.gas);
    setPressed(fuelBtns, 'data-inset-fuel', resolved.fuel);
    setPressed(controlBtns, 'data-inset-control', resolved.control);

    const variant = findVariant(resolved);
    if (variant) {
      variantInput.value = String(variant.id);
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (updateGallery) {
      showThumb(preferredMedia(resolved.fuel));
    }
  }

  gasBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      root.setAttribute('data-selected-gas', btn.getAttribute('data-inset-gas'));
      apply(false);
    });
  });
  fuelBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      root.setAttribute('data-selected-fuel', btn.getAttribute('data-inset-fuel'));
      apply(true);
    });
  });
  controlBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (btn.disabled) return;
      root.setAttribute('data-selected-control', btn.getAttribute('data-inset-control'));
      apply(false);
    });
  });

  root.querySelectorAll('[data-choose-fuel]').forEach((btn) => {
    btn.addEventListener('click', () => {
      root.setAttribute('data-selected-fuel', btn.getAttribute('data-choose-fuel'));
      apply(true);
      root.querySelector('.inset-gas-steps')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', (event) => {
      event.preventDefault();
      showThumb(thumb);
    });
  });

  const modal = root.querySelector('[data-inset-modal]');
  const modalPanel = modal && modal.querySelector('.inset-gas-modal__panel');
  const closeBtn = modal && modal.querySelector('[data-close-guide]');
  let guideOpener = null;

  function closeGuide() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    modal.querySelectorAll('[data-guide-panel]').forEach((panel) => {
      panel.hidden = true;
    });
    document.body.classList.remove('is-scroll-locked');
    if (guideOpener && typeof guideOpener.focus === 'function') guideOpener.focus();
    guideOpener = null;
  }

  function openGuide(name, opener) {
    if (!modal || !modalPanel) return;
    const panel = modal.querySelector('[data-guide-panel="' + name + '"]');
    if (!panel) return;
    modal.querySelectorAll('[data-guide-panel]').forEach((other) => {
      other.hidden = other !== panel;
    });
    const title = panel.querySelector('.inset-guide__title');
    if (title && title.id) modalPanel.setAttribute('aria-labelledby', title.id);
    guideOpener = opener || null;
    modal.hidden = false;
    document.body.classList.add('is-scroll-locked');
    modalPanel.scrollTop = 0;
    if (closeBtn) closeBtn.focus();
  }

  root.querySelectorAll('[data-open-guide]').forEach((btn) => {
    btn.addEventListener('click', () => {
      openGuide(btn.getAttribute('data-open-guide'), btn);
    });
  });
  if (modal) {
    modal.addEventListener('click', (event) => {
      if (event.target === modal || event.target.closest('[data-close-guide]')) {
        closeGuide();
      }
    });
    document.addEventListener('keydown', (event) => {
      if (modal.hidden) return;
      if (event.key === 'Escape') {
        closeGuide();
        return;
      }
      if (event.key !== 'Tab' || !modalPanel) return;
      const focusable = modalPanel.querySelectorAll(
        'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  apply(true);
})();
